import "../assets/css/Header.css";
import logo from "../assets/images/main-logo.png";
import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Header() {
  const { t, i18n } = useTranslation();

  const closeMobileMenu = () => {
    if (window.innerWidth >= 992) return;

    const collapse = document.getElementById("mainNavbar");
    const toggler = document.querySelector(".navbar-toggler");

    if (!collapse || !collapse.classList.contains("show")) return;

    collapse.classList.remove("show");

    if (toggler) {
      toggler.classList.add("collapsed");
      toggler.setAttribute("aria-expanded", "false");
    }
  };

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("lang", lang);
    closeMobileMenu();
  };

  const currentLang = i18n.language?.slice(0, 2).toUpperCase();

  return (
    <>
      {/* MOBILE BACKDROP */}
      <div
        className="mobile-nav-backdrop"
        onClick={closeMobileMenu}
      ></div>

      <div className="container no-h new-container">
        <nav className="navbar navbar-expand-lg navbar-dark custom-navbar">

          {/* BRAND → HOME */}
          <Link
            className="navbar-brand"
            to="/"
            onClick={closeMobileMenu}
          >
            <img
              src={logo}
              alt="Auto Assure"
              className="navbar-logo"
            />
          </Link>

          {/* MOBILE CONTROLS */}
          <div className="mobile-controls d-lg-none">

            {/* LANGUAGE */}
            <div className="dropdown lang-wrapper">
              <button
                type="button"
                className="btn lang-btn dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                🌐 {currentLang}
              </button>

              <ul className="dropdown-menu dropdown-menu-end">
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => changeLanguage("en")}
                  >
                    English
                  </button>
                </li>
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => changeLanguage("hi")}
                  >
                    हिन्दी
                  </button>
                </li>
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => changeLanguage("ar")}
                  >
                    العربية
                  </button>
                </li>
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => changeLanguage("ru")}
                  >
                    Русский
                  </button>
                </li>
              </ul>
            </div>

            {/* TOGGLER */}
            <button
              className="navbar-toggler border-0 collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#mainNavbar"
              aria-controls="mainNavbar"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>

          {/* MENU */}
          <div
            className="collapse navbar-collapse justify-content-end"
            id="mainNavbar"
          >
            <ul className="navbar-nav align-items-lg-center text-center c-nav">

              {/* HOME */}
              <li className="nav-item">
                <NavLink
                  to="/"
                  end
                  className="nav-link"
                  onClick={closeMobileMenu}
                >
                  {t("nav.home")}
                </NavLink>
              </li>

              {/* ABOUT */}
              <li className="nav-item">
                <NavLink
                  to="/about"
                  className="nav-link"
                  onClick={closeMobileMenu}
                >
                  {t("nav.about")}
                </NavLink>
              </li>

              {/* INVENTORY */}
              <li className="nav-item">
                <NavLink
                  to="/inventory"
                  className="nav-link"
                  onClick={closeMobileMenu}
                >
                  {t("nav.inventory")}
                </NavLink>
              </li>

              {/* CONTACT */}
              <li className="nav-item">
                <NavLink
                  to="/contact"
                  className="nav-link"
                  onClick={closeMobileMenu}
                >
                  {t("nav.contact")}
                </NavLink>
              </li>

              {/* DESKTOP LANGUAGE */}
              <li className="nav-item dropdown ms-lg-3 d-none d-lg-block">
                <button
                  type="button"
                  className="btn lang-btn dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  🌐 {currentLang}
                </button>

                <ul className="dropdown-menu dropdown-menu-end">
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => changeLanguage("en")}
                    >
                      English
                    </button>
                  </li>
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => changeLanguage("hi")}
                    >
                      हिन्दी
                    </button>
                  </li>
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => changeLanguage("ar")}
                    >
                      العربية
                    </button>
                  </li>
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => changeLanguage("ru")}
                    >
                      Русский
                    </button>
                  </li>
                </ul>
              </li>

              {/* BOOK A CALL */}
              <li className="nav-item mt-2 mt-lg-0 ms-lg-3">
                <Link
                  to="/contact"
                  className="btn c-btn px-4 w-100 nav-contact-btn"
                  onClick={closeMobileMenu}
                >
                  {t("nav.bookCall")}
                </Link>
              </li>

            </ul>
          </div>
        </nav>
      </div>
    </>
  );
}

export default Header;
